import { makeStyles } from '@material-ui/core/styles';
import { colors } from '../../utils';

export const useStyles = makeStyles((theme) => ({
  paper: {
    padding: theme.spacing(2),
    display: 'flex',
    overflow: 'auto',
    flexDirection: 'column',
    minHeight: 200
  },
  formControl: {
    margin: theme.spacing(1)
  },
  bold: {
    fontWeight: 'bold'
  },
  headerRightSection: {
    flex: 1,
    textAlign: 'right',
    flexDirection: 'row-reverse'
  },
  displayNone: {
    display: 'none'
  },
  ordersTable: {
    marginTop: theme.spacing(2)
  },
  tableHeader: {
    background: colors.defaultGrey
  }
}));
